(() => {
  let frame;
  const setViewport = () => {
    cancelAnimationFrame(frame);
    frame=requestAnimationFrame(()=>document.documentElement.style.setProperty('--slimiee-visual-height',`${window.visualViewport?.height || innerHeight}px`));
  };
  setViewport();
  window.visualViewport?.addEventListener('resize',setViewport,{passive:true});
  window.addEventListener('resize',setViewport,{passive:true});
  document.querySelectorAll('.arrivals-page').forEach((root,index)=>{
    const header=root.querySelector(':scope > .topbar');
    const navigation=root.querySelector(':scope > .catalog-nav');
    if(!header||!navigation)return;
    let toggle=header.querySelector('.menu-button');
    if(!toggle){toggle=document.createElement('button');toggle.type='button';toggle.className='icon-button menu-button';header.prepend(toggle);}
    toggle.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8h16M4 16h16"/></svg>';
    toggle.setAttribute('aria-label','Browse collections');toggle.setAttribute('aria-expanded','false');
    const drawer=document.createElement('dialog');drawer.className='mobile-collection-drawer';drawer.id='slimieeCollections'+index;toggle.setAttribute('aria-controls',drawer.id);
    const title=document.createElement('h2');title.textContent='Find your fit.';title.id=drawer.id+'Title';drawer.setAttribute('aria-labelledby',title.id);
    const drawerHead=document.createElement('div');drawerHead.className='collection-drawer-head';
    const closeButton=document.createElement('button');closeButton.type='button';closeButton.className='icon-button';closeButton.setAttribute('aria-label','Close collections menu');closeButton.textContent='×';
    drawerHead.append(title,closeButton);
    const menu=navigation.cloneNode(true);menu.className='mobile-collection-links';menu.setAttribute('aria-label','Collections');
    const more=[...menu.querySelectorAll('a')].find(a=>a.textContent.trim()==='MORE');
    let moreLink;
    if(more){moreLink=more.cloneNode(true);more.remove();moreLink.textContent='Explore all collections';moreLink.className='collection-drawer-more';}
    drawer.append(drawerHead,menu);if(moreLink)drawer.append(moreLink);root.append(drawer);
    toggle.setAttribute('aria-haspopup','dialog');
    const closeMenu=()=>{drawer.close();toggle.setAttribute('aria-expanded','false');toggle.focus();};
    toggle.addEventListener('click',event=>{
      event.preventDefault();event.stopImmediatePropagation();
      if(drawer.open)closeMenu();else{drawer.showModal();toggle.setAttribute('aria-expanded','true');}
    },true);
    closeButton.addEventListener('click',closeMenu);
    drawer.addEventListener('close',()=>toggle.setAttribute('aria-expanded','false'));
    drawer.addEventListener('click',event=>{
      const link=event.target.closest('a[href]');
      if(link){
        event.preventDefault();event.stopPropagation();
        const destination=link.href;
        drawer.close();toggle.setAttribute('aria-expanded','false');
        window.location.assign(destination);
        return;
      }
      if(event.target===drawer){const r=drawer.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right)closeMenu();}
    });
  });
  const standalone=matchMedia('(display-mode: standalone)').matches || navigator.standalone;
  if(standalone)return;
  let host;
  const close=()=>host?.querySelector('dialog').close();
  const show=()=>{
    if(!host){
      host=document.createElement('div');host.className='arrivals-page mobile-help-host';
      host.innerHTML='<dialog class="home-screen-help" aria-labelledby="homeScreenTitle"><button type="button" class="close-button" aria-label="Close Home Screen instructions">×</button><h2 id="homeScreenTitle">Keep Slimiee Fit close.</h2><p>Add a shortcut to your iPhone Home Screen.</p><ol><li>Open this page in Safari.</li><li>Tap the Share button.</li><li>Choose <strong>Add to Home Screen</strong>, then tap <strong>Add</strong>.</li></ol><p>If you don’t see that option, scroll through the actions in the Share menu.</p><button class="button button-dark" type="button" data-install-close>Got it</button></dialog>';
      document.body.append(host);
      host.querySelector('.close-button').addEventListener('click',close);
      host.querySelector('[data-install-close]').addEventListener('click',close);
    }
    host.querySelector('dialog').showModal();
  };
  document.querySelectorAll('.arrivals-page footer').forEach(footer=>{
    const button=document.createElement('button');button.type='button';button.className='home-screen-button';button.textContent='Add to Home Screen';button.addEventListener('click',show);footer.append(button);
  });
})();
